import { defineMessages } from 'react-intl'

const messages = defineMessages({
  relatedDocuments: {
    id: 'RelatedDocumentsDraggable.relatedDocuments',
    description: 'Texto de Análisis relacionados',
    defaultMessage: 'Análisis relacionados'
  }
})

export default messages



// WEBPACK FOOTER //
// ./src/modules/RelatedDocuments/RelatedDocumentsDraggable/messages.js